const ProductApprovalChanges = ({ changes, title = "Changes awaiting review", compact = false }) => {
  if (!changes?.length) return null;

  return (
    <section className={`product-approval-changes${compact ? " product-approval-changes--compact" : ""}`}>
      <h3 className="product-approval-changes__title">{title}</h3>
      <ul className="product-approval-changes__list">
        {changes.map((change, index) => (
          <li key={`${change.field}-${index}`}>
            <div className="product-approval-changes__label">{change.label}</div>
            <div className="product-approval-changes__values">
              <div className="product-approval-changes__value product-approval-changes__value--from">
                <span className="product-approval-changes__value-tag">Before</span>
                <span className="product-approval-changes__value-text">{change.from || "None"}</span>
              </div>
              <span className="product-approval-changes__arrow" aria-hidden="true">
                →
              </span>
              <div className="product-approval-changes__value product-approval-changes__value--to">
                <span className="product-approval-changes__value-tag">After</span>
                <span className="product-approval-changes__value-text">{change.to || "None"}</span>
              </div>
            </div>
            {change.detail && (
              <p className="product-approval-changes__detail">{change.detail}</p>
            )}
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ProductApprovalChanges;
